import {baseUrl,request} from './axios.js'

// const getToken = (data) => {
//   return request('GET', 'TokenService/GetSignToken', data)
// }

// 登录接口
const userLogin = (data) => {
  return request('POST', 'ADService/PostLogin', data)
}

// 获取组织架构节点
const getDepartmentNode = (data) => {
  return request('get', 'ADService/GetAD', data)
}

//获取默认OU
const getDefaultOU=()=>{
  return request('GET','ADService/GetDefaultOU')
}

//获取标签栏名称
const getTabsName=()=>{
  return request('GET','ADService/GetTabsName')
}

// 获取加密模板
const getTemplates = () => {
  return request('get', 'Evergrand/GetTemplates_Service')
}

// 查找特定人员和部门
const getSearchData = (data) => {
  return  request('GET', 'ADService/GetADSearch', data)
}

// 模板加密
const encodeForTemplate = (data, header) => {
  return request('POST', 'Evergrand/PostEncryptForTemp_Service', data, header)
}

// 自定义加密
const encodeForCustom = (data, header) => {
  return request('POST', 'Evergrand/PostEncryptForUser_Service', data, header)
}

//字符串加密
const postEncrypt = (str) => {
  return request('post', 'Encrypt/PostEncrypt', str)
}

// 下载文件
const getDownloadFile = (data) => {
  return request('GET', 'upload/GetFile', data)
} 
//获取加密记录
const postEncryptList = (data) => {
  return request('post', 'Evergrand/PostEncryptList', data)
}
const getCopyRight=(data)=>{
  return request('GET','Evergrand/GetCopyRight', data)
}

export {
  //getToken,
  userLogin,
  getTemplates,
  getDepartmentNode,
  encodeForTemplate,
  encodeForCustom,
  postEncrypt,
  getSearchData,
  getDownloadFile,
  postEncryptList,
  getCopyRight,
  getDefaultOU,
  getTabsName,
  baseUrl
}


// WEBPACK FOOTER //
// ./src/common/http/server.js